var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { constructActions } from '../actions';
import { validateFlowSpecification } from '../helpers';
import { constructParameters } from '../parameters';
import { constructTriggerCall } from '../triggers';
import { DefinitionType } from '../types';
export const constructFromBlueprintDefinition = (blueprintDef, resourceRegistry, symbolTable, errors) => __awaiter(void 0, void 0, void 0, function* () {
    const definition = blueprintDef.blueprint;
    errors = errors.concat(validateFlowSpecification(definition.spec));
    const parameters = constructParameters(definition.params);
    const trigger = yield constructTriggerCall(definition.spec.trigger, resourceRegistry, symbolTable);
    const actions = yield constructActions(definition.spec.actions, resourceRegistry, symbolTable);
    return {
        type: DefinitionType.Blueprint,
        name: definition.name,
        description: definition.description,
        tags: definition.tags,
        trigger,
        parameters,
        actions: actions !== null && actions !== void 0 ? actions : [],
        isDerived: false,
        errors,
    };
});
//# sourceMappingURL=blueprint.js.map